import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { IExtensionTipsService } from 'vscode/vscode/vs/platform/extensionManagement/common/extensionManagement.service';
import { ExtensionRecommendations } from './extensionRecommendations.js';
import { localizeWithPath } from 'vscode/vscode/vs/nls';

const _moduleId = "vs/workbench/contrib/extensions/browser/exeBasedRecommendations";
let ExeBasedRecommendations = class ExeBasedRecommendations extends ExtensionRecommendations {
    get otherRecommendations() { return (
         (this._otherTips.map(tip => this.toExtensionRecommendation(tip)))
    ); }
    get importantRecommendations() { return (
         (this._importantTips.map(tip => this.toExtensionRecommendation(tip)))
    ); }
    get recommendations() { return [...this.importantRecommendations, ...this.otherRecommendations]; }
    constructor(extensionTipsService) {
        super();
        this.extensionTipsService = extensionTipsService;
        this._otherTips = [];
        this._importantTips = [];
    }
    getRecommendations(exe) {
        const important = ( (this._importantTips
            .filter(tip => tip.exeName.toLowerCase() === exe.toLowerCase())
            .map(tip => this.toExtensionRecommendation(tip))));
        const others = ( (this._otherTips
            .filter(tip => tip.exeName.toLowerCase() === exe.toLowerCase())
            .map(tip => this.toExtensionRecommendation(tip))));
        return { important, others };
    }
    async doActivate() {
        this._otherTips = await this.extensionTipsService.getOtherExecutableBasedTips();
        await this.fetchImportantExeBasedRecommendations();
    }
    async fetchImportantExeBasedRecommendations() {
        if (!this._importantExeBasedRecommendations) {
            this._importantExeBasedRecommendations = this.doFetchImportantExeBasedRecommendations();
        }
        return this._importantExeBasedRecommendations;
    }
    async doFetchImportantExeBasedRecommendations() {
        const importantExeBasedRecommendations = ( (new Map()));
        this._importantTips = await this.extensionTipsService.getImportantExecutableBasedTips();
        this._importantTips.forEach(tip => importantExeBasedRecommendations.set(tip.extensionId.toLowerCase(), tip));
        return importantExeBasedRecommendations;
    }
    toExtensionRecommendation(tip) {
        return {
            extension: tip.extensionId.toLowerCase(),
            reason: {
                reasonId: 2 ,
                reasonText: ( localizeWithPath(
                    _moduleId,
                    0,
                    "This extension is recommended because you have {0} installed.",
                    tip.exeFriendlyName
                ))
            }
        };
    }
};
ExeBasedRecommendations = ( (__decorate([
    ( (__param(0, IExtensionTipsService)))
], ExeBasedRecommendations)));

export { ExeBasedRecommendations };
